import mitt, { Emitter } from 'mitt'
import { App, inject } from 'vue';

const bus: Emitter<any> = mitt();

const injectionKey = Symbol('bus')

export const useBus = () => inject(injectionKey) as Emitter<any>

export default ({ app }: { app: App<any> }) => {
  app.config.globalProperties.$bus = bus
  app.provide(injectionKey, bus);
}
